'use client';

import { useTimezoneContext } from '@spikemark/ui/components/client-time';
import { ButtonGroup, type ButtonGroupOption } from '@spikemark/ui/components/ui/button-group';
import { FC } from 'react';
const options: ButtonGroupOption[] = [{
  label: 'My Time',
  value: 'my-time'
}, {
  label: 'Event Time',
  value: 'event-time'
}];
export const TimezoneSelector: FC = () => {
  const {
    timezone,
    view,
    setView
  } = useTimezoneContext();
  return timezone && view ? <ButtonGroup size="sm" options={options} mutable={false} value={view} onChange={setView} data-sentry-element="ButtonGroup" data-sentry-component="TimezoneSelector" data-sentry-source-file="timezone-selector.tsx" /> : null;
};